<template>
  <div class="mt-6">
    <Pagination
      v-model="page"
      :per-page="hitsPerPage || 0"
      :records="nbHits || 0"
      :options="{
        template: shallowRef(CustomPagination),
        edgeNavigation: false,
        chunksNavigation: 'scroll',
        chunk: 3,
        hideCount: true,
      }"
      @paginate="paginate"
    ></Pagination>
  </div>
</template>

<script lang="ts" setup>
import Pagination from 'v-pagination-3'
import { useRouteQuery } from '@vueuse/router'
import CustomPagination from '../common/CustomPagination.vue'

const {
  hitsPerPage = undefined,
  nbHits = undefined,
  nbPages: _nbPages = undefined,
  currentPage = undefined,
} = defineProps<{
  hitsPerPage?: number
  nbHits?: number
  nbPages?: number
  currentPage?: number
}>()

const emit = defineEmits(['updated'])

const pageQuery = useRouteQuery<string | string[] | null>('page')

function normalizedQueryPage(): number {
  const raw = pageQuery.value
  const s = Array.isArray(raw) ? raw[0] : raw
  if (s == null || s === '') return NaN
  const n = Number(s)
  return Number.isFinite(n) ? n : NaN
}

function resolveSyncedPage(p: number | undefined): number {
  const q = normalizedQueryPage()
  if (p != null && p > 0) return p
  if (!Number.isNaN(q) && q > 0) return q
  return 1
}

const page = ref(resolveSyncedPage(currentPage))

const isUpdatingProgrammatically = ref(false)

watch(
  () => [currentPage, pageQuery.value] as const,
  ([p]) => {
    isUpdatingProgrammatically.value = true
    page.value = resolveSyncedPage(p)
    nextTick(() => {
      isUpdatingProgrammatically.value = false
    })
  }
)

function paginate(page: number) {
  // Only emit if not updating programmatically
  if (!isUpdatingProgrammatically.value) {
    emit('updated', page)
  }
}
</script>
<style scoped></style>
